/**
 * BLOOM 계약. `docs/13-bloom-contracts.md` §1 이 명세이고 이 파일이 그 구현이다.
 *
 * `packages/bloom-server` 의 DTO 와 `packages/bloom-app` 이 전부 여기서 import 한다.
 * 어느 쪽에서도 재선언하지 말 것 (CLAUDE.md 절대 규칙 10).
 *
 * **이 파일은 TV2M 계약을 대체하지 않는다.** `tv2m.ts` 는 위탁형(Mode A) 경로에서
 * 그대로 유효하고, 여기 있는 것은 자가발송형(Mode B)이 더하는 표면이다.
 */
// ── 1.1 통합 모드 ──────────────────────────────────────────────
/**
 * 통합 모드. **배포 설정이지 서로 다른 코드가 아니다** (절대 규칙 17).
 * - `delegated`: 구독·VAPID·발송이 TV2M 에 있다 (v7 현행, Mode A)
 * - `federated`: 구독·VAPID·발송이 BLOOM Server 에 있다 (BLOOM 기본, Mode B)
 */
export const BLOOM_INTEGRATION_MODES = ['delegated', 'federated'];
export function isBloomIntegrationMode(value) {
    return BLOOM_INTEGRATION_MODES.includes(value);
}
// ── 1.2 인증 ───────────────────────────────────────────────────
/**
 * `Authorization: Bearer {token}`.
 *
 * 관리자 세션 쿠키(`bloom_admin_session`)와 **절대 섞지 않는다** — 자격 셋이
 * 한 서버에 공존하고(`docs/13` §3.3), 섞이면 관리자 권한이 시청자 토큰으로 열린다.
 */
export const BLOOM_AUTH_HEADER = 'Authorization';
export const BLOOM_AUTH_SCHEME = 'Bearer';
/**
 * 네이티브 발송 수단. **`PushProvider` 의 부분집합이고 그것으로 강제된다** —
 * `satisfies` 가 어긋나면 컴파일이 깨지므로 두 목록이 갈라질 수 없다.
 *
 * `webpush` 가 여기 없는 이유: 웹 구독은 `pushSubscription` 이 실어 나르고, 이 자리는
 * **그 대신 오는 것**이다.
 */
export const NATIVE_PUSH_PROVIDERS = ['apns', 'fcm'];
export const NATIVE_PUSH_ENVIRONMENTS = ['sandbox', 'production'];
export function isNativePushProvider(v) {
    return NATIVE_PUSH_PROVIDERS.includes(v);
}
export function isNativePushEnvironment(v) {
    return NATIVE_PUSH_ENVIRONMENTS.includes(v);
}
//# sourceMappingURL=bloom.js.map